import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private titleService: Title) { }

  // set pageTitle(value: string) {
  //   this.titleService.setTitle(`Maine ${value}`);
  // }


}
